import React from 'react';
import Modal from 'react-modal';
import ReactPlayer from 'react-player';
import { AuthContext } from '../../context/AuthContextProvider';

let isMobile = window.innerWidth < 767;

const NoticeModal = ({ openModal, setModalOpen, image, video }) => {
  const { setIsNoticeRead } = React.useContext(AuthContext);

  const customStyles = {
    content: {
      top: !isMobile && '55%',
      left: !isMobile && '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: isMobile ? '' : '-50%',
      transform: isMobile ? '' : 'translate(-50%, -50%)',
      width: isMobile ? 'auto' : '800px',
      height: isMobile ? 'auto' : '480px',
      borderRadius: '8px',
      zIndex: '100',
      margin: isMobile ? '10px' : '0',
    },
  };

  const closeModal = () => {
    setIsNoticeRead(true);
    setModalOpen(false);
  };

  return (
    <Modal isOpen={openModal} onRequestClose={closeModal} style={customStyles} overlayClassName="modal-overlay">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h4>Notice</h4>
        <span
          style={{
            fontSize: '20px',
            fontWeight: 'bold',
            cursor: 'pointer',
            color: '#333',
            display: 'inline-block',
            padding: '4px',
            borderRadius: '50%',
            backgroundColor: '#f5f5f5',
            textAlign: 'center',
            lineHeight: '1',
            width: '30px',
            height: '30px',
            border: '1px solid #f5f5f5',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          }}
          onClick={() => closeModal()}
        >
          ✕
        </span>
      </div>
      <hr />
      <div style={{ width: '100%', height: '80%' }}>
        {video ? (
          <ReactPlayer
            controls
            url={video}
            light={
              <img
                src={image}
                alt="emptyImg"
                className="img-fluid"
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            }
            height="100%"
            width="100%"
          />
        ) : (
          <img
            src={image}
            alt="emptyImg"
            className="mt-3"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        )}
      </div>
    </Modal>
  );
};

export default NoticeModal;
